const isJSON = (stringParse) => {
  if (typeof stringParse === 'string') {
    try {
      JSON.parse(stringParse)
      return true
    } catch (error) {
      console.log(error)
      return false
    }
  }
  return false
}
/** 通用缓存类 */
export default class Storage {
  /** 设置storage */
  static set(key, object, outtime) {
    const ctime = Date.now() / 1000 // 获取存数据的时间
    const exp = outtime || 24 * 60 * 60 // outtime 是 秒为单位的过期时间
    const outObject = {
      // 时间和数据
      outime: ctime + exp,
      data: object,
    }
    localStorage.setItem(key, JSON.stringify(outObject))
  }

  /** 获取storage */
  static get(key) {
    const dataString = window.localStorage.getItem(key) || ''
    // 初始化没有数据
    if ([null, '', undefined].includes(dataString)) {
      return null
    }

    const data = dataString && isJSON(dataString) ? JSON.parse(dataString) : ''
    // 判断过期时间 和获取数据的时间对比 大于过期时间说明超时
    if (data.outime >= Date.now() / 1000) {
      return data.data
    }
    return null
  }

  /** 清空某个字段缓存 */
  static clear(key) {
    window.localStorage.removeItem(key)
  }
}
